import { Button, Group, Modal, Text } from "@mantine/core";

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function LogoutModal({ opened, onClose, onConfirm }: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title="Log Out?" centered size="sm">
      <Text fz="sm" c="dimmed" mb="lg">
        Are you sure you want to log out of your account?
      </Text>
      <Group justify="flex-end">
        <Button style={{ backgroundColor: "#BE220C" }} onClick={onConfirm}>
          Log Out
        </Button>
      </Group>
    </Modal>
  );
}
